import {FC, ReactNode} from 'react';
import * as css from './SectionBox.css';

interface SectionBoxProps {
    title: string;
    subtitle?: string;
    titleIcon?: ReactNode;
    children: ReactNode;
}

const SectionBox: FC<SectionBoxProps> = ({title, subtitle, titleIcon, children}) => (
    <css.box>
        <css.header>
            <css.titleRow>
                {titleIcon}
                <css.title>{title}</css.title>
            </css.titleRow>
            {subtitle && <css.subtitle>{subtitle}</css.subtitle>}
        </css.header>
        {children}
    </css.box>
);

export default SectionBox;
